import React from 'react';

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero" style={{
          background: `linear-gradient(rgba(13, 63, 105, 0.85), rgba(27, 164, 222, 0.85)), url('/images/code.png') no-repeat center right/cover`
        }}>
        <div className="container">
          <h1>About Us</h1>
          <p>Driving Africa's digital future through innovative technology solutions crafted in Nairobi.</p>
        </div>
      </section>

      {/* About Content */}
      <section id="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Driving Africa's Digital Future</h2>
              <p>Founded in Nairobi, Kenya, Zanify Technologies was born from a passion for technology and a belief in the immense potential of the African continent. We saw a need for high-quality, bespoke software that addresses local problems with world-class solutions.</p>
              <p>Our name, "Zanify," embodies our mission: to amplify and empower businesses through the power of technology. We specialize in mobile app development, creating solutions that transform how businesses operate and connect with their customers.</p>
              <p>We are a diverse collective of talented developers, creative designers, and strategic project managers, all united by a shared drive to build digital solutions that matter. Our roots in Nairobi's vibrant tech ecosystem give us a unique and dynamic perspective.</p>
            </div>
            <div className="about-image">
              <img src="/images/africandev.jpg" alt="About Zanify Technologies" />
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h3>Our Mission</h3>
              <p>To partner with forward-thinking businesses and entrepreneurs to create innovative, scalable, and impactful digital products that drive progress and success.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h3>Our Vision</h3>
              <p>To be the leading catalyst for digital transformation in East Africa, recognized for our technical excellence and profound client impact.</p>
            </div>
          </div>

          {/* Values */}
          <div className="section-title" style={{marginTop: '80px'}}>
            <h2>Our Values</h2>
            <p>The principles that guide everything we do</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation</h3>
              <p>We constantly explore new technologies and creative approaches to solve complex problems.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Collaboration</h3>
              <p>We see ourselves as an extension of your team, working together to achieve your goals.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-award"></i>
              </div>
              <h3>Excellence</h3>
              <p>We are committed to delivering superior quality in every project we undertake.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Integrity</h3>
              <p>We build relationships on trust, transparency, and honesty with all our clients.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="services-overview">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Zanify?</h2>
            <p>What sets us apart as Nairobi's premier mobile app developers</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Local Insight</h3>
              <p>Based in Nairobi, we understand the unique opportunities and challenges of the African market.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>Global Standards</h3>
              <p>We deliver solutions that compete on a global stage while addressing local needs.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>User-Centered Design</h3>
              <p>We put your users at the core of everything we build, ensuring intuitive and engaging experiences.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3>Agile Development</h3>
              <p>We work in fast, transparent sprints, keeping you involved at every stage of the process.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;